import type { FeatureManagerDialogType } from '../../feature-manager/types';

export const METAGAME_EVENTS_DIALOG_TYPES: Record<string, FeatureManagerDialogType> = {
  PRIZE_DROP: 'PrizeDrop',
  PRIZE_DROP_PRE_MESSAGE: 'PrizeDropPreMessage',
  HAMMERS: 'Hammers',
  WELCOME_HUMMERS_METAGAME: 'WelcomeHummersMetagame',
  PUZZLE_PRE_MESSAGE: 'PuzzlePreMessage',
  TRAIL: 'Trail',
  TRAIL_PRE_MESSAGE: 'TrailPreMessage',
};
